import { useQuery } from '@tanstack/react-query'
import { providersAPI, adminAPI } from '../services/api'

export const useProviders = () => {
  return useQuery({
    queryKey: ['admin', 'providers'],
    queryFn: async () => {
      const response = await providersAPI.getProviders()
      // Backend returns { message, providers: [...], summary: {...} }
      // Component expects { providers: [...] }
      return {
        providers: response.data.providers || response.data.data || [],
        summary: response.data.summary || {}
      }
    },
    staleTime: 60000, // 1 minute
    refetchOnWindowFocus: false,
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
  })
}

export const useProviderDetails = (providerId, options = {}) => {
  return useQuery({
    queryKey: ['admin', 'provider-details', providerId],
    queryFn: async () => {
      if (!providerId) {
        throw new Error('Provider ID is required')
      }
      
      const response = await adminAPI.get(`/providers/${providerId}`)
      return response.data.data
    },
    enabled: !!providerId && options.enabled !== false,
    staleTime: 30000, // 30 seconds
    refetchOnWindowFocus: false,
    ...options,
  })
}

export const useProviderStats = () => {
  return useQuery({
    queryKey: ['admin', 'providers', 'stats'],
    queryFn: async () => {
      const response = await adminAPI.get('/providers/stats')
      return response.data.data
    },
    staleTime: 2 * 60 * 1000, // 2 minutes
    refetchOnWindowFocus: false,
  })
}

export const useProviderPrices = (providerId, { enabled = true } = {}) => {
  return useQuery({
    queryKey: ['admin', 'provider-prices', providerId],
    queryFn: async () => {
      if (!providerId) {
        throw new Error('Provider ID is required')
      }
      
      const response = await adminAPI.get(`/providers/${providerId}/prices`)
      return response.data.data
    },
    enabled: !!providerId && enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  })
}